/** @format */
import { LegacyProductImage } from '@toucan/client/global/product';

export const getSupportingImagesUrls = (
    supportingImages: LegacyProductImage[]
) => supportingImages.flatMap(({ url }) => (url ? [url] : []));
